import {Router} from "./router.jsx";
import { createTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store from "./redux/store";
import { persistor } from "./redux/store";
import "./index.css";
import { AlertMessage } from "./components/general/Alert.jsx";

const Main = () => {
  // create custom theme
  const theme = createTheme({
    // set font family to use in the project
    typography: {
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Inter",
        "Poppins",
        "sans-serif",
      ].join(","),
      h1: { fontWeight: 800, letterSpacing: 0 },
      h2: { fontWeight: 800, letterSpacing: 0 },
      h3: { fontWeight: 800, letterSpacing: 0 },
      h4: { fontWeight: 800, letterSpacing: 0 },
      h5: { fontWeight: 700, letterSpacing: 0 },
      h6: { fontWeight: 700, letterSpacing: 0 },
      button: { fontWeight: 700, letterSpacing: 0 },
    },
    palette: {
      mode: "light",
      primary: {
        main: "#FE1F02",
        dark: "#C91906",
        light: "#FFF0ED",
      },
      secondary: {
        main: "#003846",
        dark: "#071F28",
        light: "#DDF7FA",
      },
      text: {
        main: "#F3E9DF",
        primary: "#071F28",
        secondary: "#60717A"

      },
      error: {
        main: "#ff0000",
      },
      warning: {
        main: "#ffbb00",
      },
      info: {
        main: "#2563EB",
      },
      success: {
        main: "#16A34A",
      },
      shadow: {
        main: "rgba(7, 31, 40, 0.12)",
        light: "rgba(7, 31, 40, 0.06)",
      },
      background: {
        default: "#FBF8F5",
        paper: "#FFFFFF",
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: "#FBF8F5",
            color: "#071F28",
            textRendering: "optimizeLegibility",
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            boxShadow: "none",
            textTransform: "none",
            minHeight: 44,
            transition: "transform 220ms cubic-bezier(0.16, 1, 0.3, 1), background-color 220ms ease, border-color 220ms ease, box-shadow 220ms ease",
            "&:hover": {
              transform: "translateY(-1px)",
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            boxShadow: "0 24px 70px rgba(7, 31, 40, 0.08)",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <>
        <CssBaseline />
        <Router />
        <AlertMessage />
      </>
    </ThemeProvider>
  );
};


export const MainComponent = () => {

  return (

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Main />
      </PersistGate>
    </Provider>
  )
}
